var _defs, _title, _title2, _title3, _title4, _title5, _title6, _title7, _title8, _title9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRgFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 39.31 27.55",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a6d1aa;stroke:#155e36;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#155e36;}.cls-3{fill:#c7efc7;}.cls-4{fill:#e4f4eb;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rg_mini") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.516 0.859 L 35.746 0.859 C 37.149 0.859 38.286 1.996 38.286 3.399 L 38.286 23.869 C 38.286 25.272 37.149 26.409 35.746 26.409 L 3.516 26.409 C 2.113 26.409 0.976 25.272 0.976 23.869 L 0.976 3.399 C 0.976 1.996 2.113 0.859 3.516 0.859 Z",
    className: "cls-1",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(0.488863, 0, 0, 0.440869, 10.391742, 12.156864)"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Foto")), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(250, 169, 128)",
      vectorEffect: "non-scaling-stroke"
    },
    d: "M 26.07 -0.752 L 25.003 1.876 C 24.917 7.971 32.602 8.866 32.7 1.854 L 31.789 -0.585 L 26.07 -0.752 Z",
    transform: "matrix(0, 1, -1, 0, 31.867924, -25.83436)"
  }, _title2 || (_title2 = /*#__PURE__*/React.createElement("title", null, "Pesco\xE7o"))), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(254, 187, 135)",
      vectorEffect: "non-scaling-stroke"
    },
    cx: 38.604,
    cy: 57.295,
    rx: 5.831,
    ry: 7.412,
    transform: "matrix(0, 1, -1, 0, 96.300781, -35.405552)"
  }, _title3 || (_title3 = /*#__PURE__*/React.createElement("title", null, "Rosto"))), /*#__PURE__*/React.createElement("path", {
    d: "M 41.43 -2.205 C 39.188 -1.826 37.909 -0.435 37.352 2.207 C 36.927 4.223 36.927 5.188 37.352 5.188 C 37.621 5.188 37.644 5.388 37.554 6.173 C 37.396 7.248 37.598 8.773 37.89 8.773 C 37.98 8.773 38.135 7.989 38.203 7.024 C 38.269 5.861 38.471 4.941 38.787 4.336 C 39.324 3.261 39.324 3.285 39.995 3.731 C 40.623 4.133 41.384 4.181 44.408 3.954 C 47.457 3.731 47.972 3.954 48.643 5.747 C 48.889 6.419 49.181 7.382 49.247 7.876 C 49.473 9.287 49.786 8.928 49.786 7.226 C 49.786 6.285 49.922 5.434 50.122 5.055 C 50.771 3.821 50.054 0.953 48.845 -0.077 C 48.308 -0.549 48.218 -0.705 48.442 -0.974 C 48.665 -1.243 48.51 -1.356 47.501 -1.624 C 46.314 -1.982 43.469 -2.431 42.842 -2.409 C 42.662 -2.385 42.011 -2.295 41.43 -2.205 Z",
    style: {
      vectorEffect: "non-scaling-stroke"
    },
    transform: "matrix(0, 1, -1, 0, 46.881518, -40.518296)"
  }, _title4 || (_title4 = /*#__PURE__*/React.createElement("title", null, "Cabelo"))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(248, 239, 248)",
      vectorEffect: "non-scaling-stroke"
    },
    points: "21.074 -1.803 25.434 -0.692 29.343 -1.87 26.746 7.97 24.011 7.97",
    transform: "matrix(0, 1, -1, 0, 28.2585, -22.1585)"
  }, _title5 || (_title5 = /*#__PURE__*/React.createElement("title", null, "Camisa"))), /*#__PURE__*/React.createElement("path", {
    d: "M 20.828 -1.675 C 20.624 -1.339 19.124 -0.69 15.54 0.656 C 13.88 1.259 12.312 1.911 12.044 2.067 C 11.373 2.493 10.901 3.611 10.609 5.428 C 10.476 6.278 10.318 7.265 10.274 7.601 L 10.184 8.183 L 25.173 8.183 C 33.44 8.183 40.184 8.116 40.184 8.048 C 40.184 7.221 39.467 3.837 39.155 3.186 C 38.66 2.111 38.414 1.977 34.694 0.61 C 32.97 -0.039 31.066 -0.802 30.483 -1.114 C 29.878 -1.407 29.362 -1.629 29.318 -1.585 C 29.272 -1.54 28.645 0.543 27.884 3.053 C 27.143 5.561 26.472 7.666 26.425 7.736 C 26.294 7.846 26.137 6.794 25.958 4.754 C 25.868 3.881 25.732 2.785 25.623 2.291 C 25.463 1.595 25.509 1.326 25.756 1.036 C 26.048 0.723 26.048 0.589 25.8 0.185 C 25.642 -0.085 25.353 -0.286 25.173 -0.286 C 24.995 -0.286 24.702 -0.085 24.547 0.185 C 24.3 0.589 24.3 0.723 24.568 1.015 C 24.835 1.304 24.859 1.618 24.726 2.403 C 24.612 2.963 24.457 4.352 24.367 5.495 C 24.278 6.636 24.142 7.601 24.052 7.666 C 23.962 7.713 23.425 6.166 22.842 4.24 C 21.162 -1.407 20.984 -1.922 20.828 -1.675 Z",
    style: {
      vectorEffect: "non-scaling-stroke"
    },
    transform: "matrix(0, 1, -1, 0, 28.413773, -21.954225)"
  }, _title6 || (_title6 = /*#__PURE__*/React.createElement("title", null, "Terno"))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(218, 23, 42)",
      vectorEffect: "non-scaling-stroke"
    },
    points: "24.077 -0.925 24.691 -0.925 25.307 0.009 24.798 0.785 24.783 1.185 25.708 6.937 25.77 7.542 23.151 7.535 23.986 1.17 23.964 0.761 23.439 -0.033",
    transform: "matrix(0, 1, -1, 0, 27.769, -21.152)"
  }, _title7 || (_title7 = /*#__PURE__*/React.createElement("title", null, "Gravata"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0, 1, -1, 0, 96.300781, -35.405552)"
  }, _title8 || (_title8 = /*#__PURE__*/React.createElement("title", null, "Terno dobrado")), /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(121, 121, 121)",
      vectorEffect: "non-scaling-stroke"
    },
    points: "35.414 76.073 36.64 75.294 37.783 72.449 36.531 72.291 37.83 70.059 34.064 66.057 32.066 66.056",
    transform: "matrix(-1, 0, 0, -1, 69.896004, 142.128998)"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(121, 121, 121)",
      vectorEffect: "non-scaling-stroke"
    },
    points: "42.362 65.942 43.524 66.626 44.663 69.542 43.411 69.815 45.095 71.797 41.611 76.068 39.693 76.074"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(255, 255, 255)",
      vectorEffect: "non-scaling-stroke"
    },
    points: "29.925 3.588 29.227 3.587 27.555 5.613 25.301 2.288 26.167 0.467 29.194 3.345 29.953 3.345 32.59 0.444 33.432 2.358 31.45 5.523",
    transform: "matrix(0, 1, -1, 0, 32.395, -26.338)"
  }, _title9 || (_title9 = /*#__PURE__*/React.createElement("title", null, "Colarinho")))), /*#__PURE__*/React.createElement("path", {
    d: "M 3.54 0.841 L 35.77 0.841 C 37.173 0.841 38.31 1.978 38.31 3.381 L 38.31 23.851 C 38.31 25.254 37.173 26.391 35.77 26.391 L 3.54 26.391 C 2.137 26.391 1 25.254 1 23.851 L 1 3.381 C 1 1.978 2.137 0.841 3.54 0.841 Z M 33.65 8.721 L 22.2 8.721 C 21.173 8.721 20.34 9.554 20.34 10.581 L 20.34 16.641 C 20.34 17.668 21.173 18.501 22.2 18.501 L 33.65 18.501 C 34.677 18.501 35.51 17.668 35.51 16.641 L 35.51 10.581 C 35.51 9.554 34.677 8.721 33.65 8.721 Z",
    className: "cls-1",
    style: {
      vectorEffect: "non-scaling-stroke"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.8,
    y: 21.09,
    width: 31.71,
    height: 2.57,
    style: {}
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.64,
    y: 4.27,
    width: 25.87,
    height: 2.03,
    style: {}
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 6.89,
    y: 7.51,
    width: 9.78,
    height: 14.14,
    rx: 1.86,
    transform: "translate(25.45 1.99) rotate(90)",
    style: {}
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.8,
    y: 4.27,
    width: 4.59,
    height: 2.03,
    style: {}
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRgFront);
export default __webpack_public_path__ + "static/media/rg_front.ae8f0808a7fbccf3f95546efde4ad4fa.svg";
export { ForwardRef as ReactComponent };